"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setErrResponse = exports.ValidationTypes = exports.httpMethods = void 0;
exports.convertObjectKeysToSnakeCase = convertObjectKeysToSnakeCase;
exports.setFormattedInput = setFormattedInput;
exports.createJSONStringifiedError = createJSONStringifiedError;
exports.validateParam = validateParam;
exports.validateParams = validateParams;
exports.transformToUpperUnderscore = transformToUpperUnderscore;
exports.flatNodeDevices = flatNodeDevices;
const lodash_1 = __importDefault(require("lodash"));
const snakecase_keys_1 = __importDefault(require("snakecase-keys"));
exports.httpMethods = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    PATCH: 'PATCH',
    DELETE: 'DELETE',
};
var ValidationTypes;
(function (ValidationTypes) {
    ValidationTypes["ARRAY"] = "ARRAY";
    ValidationTypes["BOOLEAN"] = "BOOLEAN";
    ValidationTypes["INTEGER"] = "INTEGER";
    ValidationTypes["NUMBER"] = "NUMBER";
    ValidationTypes["PRESENCE"] = "PRESENCE";
    ValidationTypes["STRING"] = "STRING";
    ValidationTypes["OBJECT"] = "OBJECT";
})(ValidationTypes || (exports.ValidationTypes = ValidationTypes = {}));
function convertObjectKeysToSnakeCase(obj) {
    return (0, snakecase_keys_1.default)(obj);
}
function setFormattedInput(obj) {
    const { header = {}, query = {}, body = {} } = obj;
    return {
        header,
        query: query && convertObjectKeysToSnakeCase(query),
        body: body && convertObjectKeysToSnakeCase(body),
    };
}
function createJSONStringifiedError(errObj) {
    return new Error(JSON.stringify(errObj));
}
const setErrResponse = (errMessage) => ({
    status: 400,
    statusText: 'BadRequest',
    body: {
        code: 'BadRequest',
        message: errMessage,
    },
});
exports.setErrResponse = setErrResponse;
function validateParam(method, paramName, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
param, dataType, dataStructureContentsType) {
    let errResponse;
    const errMessageType = `${method} ${paramName} is required to be of type ${dataType}.`;
    const errMessagePresence = `${method} ${paramName} is required but has not been supplied.`;
    const errMessageDefault = `${method} ${paramName} the supplied type ${dataType} is unhandled`;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let fn;
    switch (dataStructureContentsType) {
        case ValidationTypes.STRING:
            fn = lodash_1.default.isString;
            break;
        case ValidationTypes.INTEGER:
            fn = lodash_1.default.isInteger;
            break;
        case ValidationTypes.BOOLEAN:
            fn = lodash_1.default.isBoolean;
            break;
        case ValidationTypes.NUMBER:
            fn = lodash_1.default.isNumber;
            break;
        case ValidationTypes.OBJECT:
            fn = lodash_1.default.isObject;
            break;
        default:
    }
    if (dataType === ValidationTypes.STRING) {
        if (param && !lodash_1.default.isString(param))
            errResponse = (0, exports.setErrResponse)(errMessageType);
    }
    else if (dataType === ValidationTypes.INTEGER) {
        if (param && !lodash_1.default.isInteger(param))
            errResponse = (0, exports.setErrResponse)(errMessageType);
    }
    else if (dataType === ValidationTypes.BOOLEAN) {
        if (param && !lodash_1.default.isBoolean(param))
            errResponse = (0, exports.setErrResponse)(errMessageType);
    }
    else if (dataType === ValidationTypes.NUMBER) {
        if (param && !lodash_1.default.isNumber(param))
            errResponse = (0, exports.setErrResponse)(errMessageType);
    }
    else if (dataType === ValidationTypes.ARRAY) {
        if (!lodash_1.default.isNil(param) && !lodash_1.default.isArray(param)) {
            errResponse = (0, exports.setErrResponse)(errMessageType);
        }
        else if (!lodash_1.default.isEmpty(param)) {
            const [errResult] = param
                .map((e) => {
                const errMessageContentsType = `${method} ${paramName} value: ${e} is required to be type: ${dataStructureContentsType}.`;
                if (!fn(e))
                    return errMessageContentsType;
                return null;
            })
                .filter(Boolean);
            if (errResult)
                errResponse = (0, exports.setErrResponse)(errResult);
        }
    }
    else if (dataType === ValidationTypes.OBJECT) {
        if (param && !lodash_1.default.isObject(param))
            errResponse = (0, exports.setErrResponse)(errMessageType);
    }
    else if (dataType === ValidationTypes.PRESENCE) {
        if (lodash_1.default.isNil(param))
            errResponse = (0, exports.setErrResponse)(errMessagePresence);
    }
    else {
        errResponse = (0, exports.setErrResponse)(errMessageDefault);
    }
    return errResponse;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function validateParams(validationErrors) {
    for (const error of validationErrors) {
        if (error)
            throw createJSONStringifiedError(error);
    }
}
function transformToUpperUnderscore(str) {
    return str
        .replace(/([a-z])([A-Z])/g, '$1_$2') // Add underscore before each uppercase letter
        .toUpperCase(); // Convert the entire string to uppercase
}
function flatNodeDevices(nodeDevices) {
    if (!nodeDevices)
        return [];
    const devices = [];
    Object.keys(nodeDevices).forEach((connector) => {
        Object.keys(nodeDevices[connector] || {}).forEach((channel) => {
            const device = nodeDevices[connector]?.[+channel];
            if (device) {
                devices.push({
                    ...device,
                    connector: connector,
                    channel: +channel,
                });
            }
        });
    });
    return devices;
}
//# sourceMappingURL=util.js.map